var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 13.8573C1 13.8573 3.5 12.4287 6 12.4287C9.6488 12.4287 12.3512 15.2859 16 15.2859C18.5 15.2859 21 13.8573 21 13.8573",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 19.5711C1 19.5711 3.5 18.1426 6 18.1426C9.6488 18.1426 12.3512 20.9997 16 20.9997C18.5 20.9997 21 19.5711 21 19.5711",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8.14244C1 8.14244 3.5 6.71387 6 6.71387C9.6488 6.71387 12.3512 9.57101 16 9.57101C18.5 9.57101 21 8.14244 21 8.14244",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2.42857C1 2.42857 3.5 1 6 1C9.6488 1 12.3512 3.85714 16 3.85714C18.5 3.85714 21 2.42857 21 2.42857",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMaterial);
export default __webpack_public_path__ + "static/media/icn-material.a66e338e401899aefce2cdd7cee53100.svg";
export { ForwardRef as ReactComponent };